import React from "react";
import {NavLink, Route, Switch} from "react-router-dom"
import {rolePageMapping} from "./utils/roles";


const NavbarHB = (props) => {
    return (
        <div className="Navbar">
            <Switch>
                <Route>
                    <div className="tableWrapper">
                        <ul className="header">
                            {
                                rolePageMapping.accountManagement.includes(props.role)
                                &&
                                <li><NavLink to="/sps-account-home">Account Management</NavLink></li>
                            }
                            {
                                rolePageMapping.monthlyPrice.includes(props.role)
                                &&
                                <li><NavLink to="/sps-monthlyprice">Monthly Cap and Pricing</NavLink></li>
                            }
                            {
                                rolePageMapping.swcatalogupload.includes(props.role)
                                &&
                                <li><NavLink to="/sw-catalog">SW Catalog</NavLink></li>
                            }
                            {
                                rolePageMapping.administration.includes(props.role)
                                &&
                                <li><NavLink to="/sps-admin">Administration</NavLink></li>
                            }
                        </ul>
                    </div>
                </Route>
            </Switch>
        </div>
    )
}

export default NavbarHB
